export default{
  ROLLS_COUNT: 'ROLLS_COUNT'
}

export const callCenterGetters = {
  CLIENT_CURRENT_ORDER: 'CLIENT_CURRENT_ORDER',
  CLIENT_SETTED: 'CLIENT_SETTED',
  CLIENT_PHONE: 'CLIENT_PHONE',
  CLIENT_PHONE_RAW: 'CLIENT_PHONE_RAW',
  BRAND_ID: 'BRAND_ID',
  BRAND_NAME: 'BRAND_NAME',
  IS_ACCEPTED_ORDER: 'IS_ACCEPTED_ORDER',
  TYPE_DISCOUNT_OPTIONS_SELECT: 'TYPE_DISCOUNT_OPTIONS_SELECT',
  IS_ORDER_WITH_DISCOUNT: 'IS_ORDER_WITH_DISCOUNT',
  ORDER_STATUS_KEYWORD: 'ORDER_STATUS_KEYWORD',
  ORDER_HOLD_TIME: 'ORDER_HOLD_TIME',
  ORDER_TYPE_DISCOUNT: 'ORDER_TYPE_DISCOUNT',
  ORDER_TYPE_DISCOUNT_KEYWORD: 'ORDER_TYPE_DISCOUNT_KEYWORD',
  ORDER_DISCOUNT_VALUE: 'ORDER_DISCOUNT_VALUE',
  ORDER_PREV_TYPE_DISCOUNT_KEYWORD: 'ORDER_PREV_TYPE_DISCOUNT_KEYWORD',
  SUM_ORDER_DISCOUNT: 'SUM_ORDER_DISCOUNT',
  ORDER_PRODUCTS: 'ORDER_PRODUCTS',
  PROMOCODES_SELECT_OPTIONS: 'PROMOCODES_SELECT_OPTIONS',
  SELECTED_PROMOCODE: 'SELECTED_PROMOCODE',
  ORDER_PROMOCODE_ITEM: 'ORDER_PROMOCODE_ITEM',
  SUM_OF_PRODUCTS: 'SUM_OF_PRODUCTS',
  SUM_OF_PRODUCTS_WITHOUT_MOTIVATED_PRODUCTS: 'SUM_OF_PRODUCTS_WITHOUT_MOTIVATED_PRODUCTS',
  SUM_OF_PRODUCTS_WIHOUT_SALE_PRODS: 'SUM_OF_PRODUCTS_WIHOUT_SALE_PRODS',
  PROMOCODE_MIN_SUM: 'PROMOCODE_MIN_SUM',
  PROMOCODE_BRAND_ID: 'PROMOCODE_BRAND_ID',
  PROMOCODE_RESULT_TYPE: 'PROMOCODE_RESULT_TYPE',
  ORDERS_COUNT: 'ORDERS_COUNT',
  MOTIVATED_MIN_REQUIRED_SUM_OF_PRODUCTS: 'MOTIVATED_MIN_REQUIRED_SUM_OF_PRODUCTS',
  LAST_ID: 'LAST_ID',
  COLLECTED: 'COLLECTED',
  COURIER_AUTO_ASSIGN: 'COURIER_AUTO_ASSIGN'
}

export const orderWorkshopGetters = {
  STATS_WORKSHOPS: 'STATS_WORKSHOPS',
  LOADING_STATS_WORKSHOPS_OVERALL: 'LOADING_STATS_WORKSHOPS_OVERALL'
}

export const orderTimeGetters = {
  STATS_TIME_ORDER: 'STATS_TIME_ORDER',
  LOADING_STATS_TIME_ORDER: 'LOADING_STATS_TIME_ORDER'
}

export const overallWorkshopStatsGetters = {
  TABLE_OVERALL: 'TABLE_OVERALL',
  TABLE_STATS: 'TABLE_STATS',
  TABLE_COLUMNS: 'TABLE_COLUMNS',
  TABLE_STATS_M: 'TABLE_STATS_M',
  TOTAL_TURNOVER: 'TOTAL_TURNOVER',
  TOTAL_EARN_MOTIVATE: 'TOTAL_EARN_MOTIVATE'
}

export const workshopsGetters = {
  WORKSHOPS: 'WORKSHOPS'
}



// WEBPACK FOOTER //
// ./src/constants/vuexGetters.js